var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",class:{'dark':_vm.themeName=='dark'}},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("关于本站")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }